Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Gradient = ({ from, to, dir, children }) => {

  const calculateDirection = () => {
    if(dir === 'left-to-right') return 'to right'
    if(dir === 'right-to-left') return 'to left'
    if(dir === 'top-to-bottom') return '180deg'
    if(dir === 'bottom-to-top') return '0deg'
  };

  return React__namespace.createElement('span', {style: {
        background: `linear-gradient(${calculateDirection()}, ${from}, ${to})`,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }}, [children])
};

exports.default = Gradient;
//# sourceMappingURL=index.js.map
